import { takeLatest, call, put } from 'redux-saga/effects';

import * as apiCommon from '../../services/apiCommon';
import * as c from '../../constants';

export function* fetchListSystemNotesSaga(app) {
  yield takeLatest('FETCH_LIST_SYSTEM_NOTES', callFetchListSystemNotes, app);
}

function* callFetchListSystemNotes(app, action) {
  try {
    const { filters } = action;
    yield put({
      type: c.FETCH_SYSTEM_NOTES_INPROGRESS,
    });

    const dataParams = {
      filters,
      list_type: c.CHANGE_AUDIT,
    };

    const tableData = yield call(apiCommon.getDocs, app, dataParams);

    yield put({
      type: c.FETCH_SYSTEM_NOTES_DONE,
      payload: {
        rows: tableData.data,
        total_rows: tableData.total,
      },
    });
  } catch (error) {
    yield put({
      type: c.FETCH_SYSTEM_NOTES_ERROR,
      error,
    });
  }
}
